import AbstractController from '../../../../../../ig_template/Resources/Public/Src/Js/Controller/AbstractController';
import Controller from '../../../../../../ig_template/Resources/Public/Src/Js/Controller/Controller';
import TeaserSlider from '../Elements/TeaserSlider';

/**
 * Teaser Controller
 *
 * @class
 */
class TeaserController extends AbstractController {
  /**
   * @constructor
   */
  constructor() {
    super();

    Controller.registerController(this);
    this._registerElements(TeaserSlider);
  }
}

export default (new TeaserController);
